import { render, staticRenderFns } from "./exibir-legislacoes.vue?vue&type=template&id=3ac32c20&"
import script from "./exibir-legislacoes.vue?vue&type=script&lang=js&"
export * from "./exibir-legislacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac32c20')) {
      api.createRecord('3ac32c20', component.options)
    } else {
      api.reload('3ac32c20', component.options)
    }
    module.hot.accept("./exibir-legislacoes.vue?vue&type=template&id=3ac32c20&", function () {
      api.rerender('3ac32c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/legislacao/exibir-legislacoes.vue"
export default component.exports